import "./VyneFormSwitch.scss";
import { Form, type GetProps, Switch } from "antd";
import type { NamePath } from "antd/es/form/interface";

type FormItemProps = GetProps<typeof Form.Item>;

export interface VyneFormSwitchProps extends Readonly<Omit<FormItemProps, "virtual">> {
    name: string | NamePath<string>;
    label: string;
}

/** Helper to render a form item containing a switch. */
export const VyneFormSwitch = ({ className, ...props }: VyneFormSwitchProps) => (
    <Form.Item
        {...props}
        className={`vyne-form-switch ${className ?? ""}`}
        colon={false}
        layout="horizontal"
        valuePropName="checked"
    >
        <Switch />
    </Form.Item>
);
